import gql from "graphql-tag";

export const MY_LEAVE_GET_ORPHANED_REQUESTS_LIST_COUNT = gql`
  query orphanedRequestsCount {
    orphanedRequestsCount
  }
`;
